"use client";

import React from "react";
import { Clock, Phone, ShieldCheck, Wrench } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function Emergency() {
  const shouldReduceMotion = useReducedMotion();
  const trustHighlights = [{
    icon: Clock,
    label: "24/7 emergency dispatch"
  }, {
    icon: ShieldCheck,
    label: "Direct insurance billing"
  }, {
    icon: Wrench,
    label: "Local technicians on-site"
  }];
  return <section id="emergencycalltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        ease: "easeOut"
      }} className="relative rounded-2xl border border-border bg-muted/40 p-8 shadow-sm sm:p-12 lg:p-16">
          <div className="mx-auto max-w-3xl text-center">
            <div className="flex justify-center">
              <Badge variant="outline" className="mb-4 gap-1.5 rounded-full border-border bg-background px-3 py-1 text-xs text-foreground shadow-2xs">
                <span className="size-2 rounded-full bg-destructive animate-pulse" />
                Live 24/7 Response
              </Badge>
            </div>

            <h2 className="font-default text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              Need immediate restoration help?
            </h2>

            <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground sm:text-lg">
              Local teams are on call 24/7 across Maryland, DC, and Northern Virginia to stop ongoing damage and coordinate directly with your insurance.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button asChild size="lg" className="w-full sm:w-auto shadow-sm">
                <a href="tel:8554356631">
                  <Phone className="size-4" />
                  Call 855-435-6631
                </a>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
                <Link to="/ContactRequestServicePage">
                  Request Service
                </Link>
              </Button>
            </div>

            <div className="mt-10 flex flex-wrap items-center justify-center gap-6 border-t border-border pt-8 text-xs text-muted-foreground sm:gap-8 sm:text-sm">
              {trustHighlights.map((item, i) => {
              const IconComponent = item.icon;
              return <div key={item.label} data-index={i} className="flex items-center gap-2">
                    <IconComponent className="size-4 text-primary" />
                    <span>{item.label}</span>
                  </div>;
            })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}